import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { routes } from 'app/app.routes';
import { useSessionSelector } from '@ui-core/session/sessionSlice';
import Session from '@ui-core/session/Session';
import { fetchPermissions } from '@ui-core/security/permissionsSlice';
import { routerService } from '@router/router.service';
import { createRouter, useLocation } from '@router';
import { env } from '@config';
import LoaderOverlayFullScreen from './components/loaderOverlayFullScreen/LoaderOverlayFullScreen';

// creates a router
const Router = createRouter({
	routes: routes.app,
	loader: <LoaderOverlayFullScreen style={{}} />,
	fallback: <LoaderOverlayFullScreen style={{}} />,
});

/**
 * Application routing handler.
 *
 * Here you can define logic for authorization
 * redirection or app splitting.
 *
 * @returns {JSX.Element} application router
 */
export const AppRouter: React.FC = (): JSX.Element => {
	const dispatch = useDispatch();
	const { pathname } = useLocation();
	const { isAuthenticated } = useSessionSelector();

	useEffect(() => {
		if (
			isAuthenticated ||
			env.NODE_ENV === 'development' ||
			env.ENV === 'dev'
		) {
			const routeObjects = routerService
				.createRoutes(routes.app, '/')
				.map((route) => route);
			for (const route of routeObjects) {
				if (route.path === pathname && route.payload.profile)
					localStorage.setItem('profile', route.payload.profile);
			}
			dispatch(fetchPermissions('12312312-3'));
		} else {
			// Redirection to login from vigilancia.
			window.location.href = `${
				import.meta.env.REACT_APP_HOST_BASE
			}/achs`;
		}
	}, [pathname, dispatch, isAuthenticated]);

	return (
		<Session>
			<Router />
		</Session>
	);
};
